var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgEmptyBeehive = function SvgEmptyBeehive(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 46,
    viewBox: "0 0 154 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.9029C14.5693 43.9029 41.7078 43.0637 41.7078 28.3752C41.7078 23.759 39.6094 20.4016 36.2521 20.4016C32.8947 20.4016 30.3767 23.759 30.3767 28.3752C30.3767 37.639 44.5941 42.6678 56.8491 35.5002",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.08 3.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 16C100.238 12.7825 106.5 3.5 121.5 3.5C129 3.5 135.402 8.40166 137.5 10.5C139.598 12.5983 144.106 17.5479 144.106 21.2409C144.106 25.8573 140.329 26.2769 139.49 26.2769C138.651 26.2769 134.874 25.8573 134.874 21.2409C134.874 16.6246 140.329 9.49025 152.5 8.65091",
    stroke: "#E5E5E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.08 3.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6 20.5H58.9C58.4 22.2 58 24.1 57.7 26.1H98.8C98.5 24 98.1 22.2 97.6 20.5Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17H96.3C95.5 14.9 94.5 13.1 93.5 11.4H62.8C61.8 13.1 60.9 14.9 60 17Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9999 8C85.0999 1.2 78.1999 0 78.1999 0C78.1999 0 71.2999 1.2 65.3999 8H90.9999Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3 38.5H57.2C58.7 45.4 65 45.9 73.3 45.9V38.5Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0999 38.5V45.9C91.2999 45.9 97.6998 45.3 99.1998 38.5H83.0999Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2 30.8C80.7 30.8 82.7 32.6 83 35H99.4C99.4 33 99.3 31.2 99.2 29.4H57.2C57 31.1 57 33 57 35H73.4C73.7 32.7 75.8 30.8 78.2 30.8Z",
    fill: "#E5E5E5"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyBeehive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-beehive.49a0e866cbcb434808e66e46cfd85ddf.svg";
export { ForwardRef as ReactComponent };